import React from 'react';
import { Form, Button } from 'react-bootstrap';

export default function ServiceChoices({ id, label, value = '', options = { da: 'Da', nu: 'Nu' }, onChange }) {
  return <fieldset className="mb-3"><legend className="float-none fs-6 mb-1">{label}</legend>
    {Object.entries(options).map(([key, text]) => <Form.Check inline type="radio" key={key}
      id={`${id}-${key}`} name={id} label={text} checked={value === key} onChange={() => onChange(key)} />)}
    {value && <Button size="sm" variant="link" type="button" onClick={() => onChange('')}>Necompletat</Button>}
  </fieldset>;
}
